import { Action } from '@ngrx/store';
import { RedData } from '../models/red-data.model';

export enum RedDatasActionTypes {
  REDDATAS_QUERY = '[RedDatas] Query',
  REDDATAS_LOADED = '[RedDatas] Fetched',

  REDDATAS_ADDED = '[RedDatas] Added',
  REDDATAS_EDITED = '[RedDatas] Edited',
  REDDATAS_DELETED = '[RedDatas] Deleted',
  REDDATAS_DELETEDALL = '[RedDatas] DeletedAll',
  REDDATAS_SAVED = '[RedDatas] Saved',

  REDDATAS_ERROR = '[RedDatas] Error'
}

export class RedDatasQuery implements Action {
  readonly type = RedDatasActionTypes.REDDATAS_QUERY;
}

export class RedDatasLoaded implements Action {
  readonly type = RedDatasActionTypes.REDDATAS_LOADED;

  constructor(public payload: { reddatas: RedData[] }) {}
}

export class RedDatasAdded implements Action {
  readonly type = RedDatasActionTypes.REDDATAS_ADDED;

  constructor(public payload: { reddata: RedData }) {}
}

export class RedDatasEdited implements Action {
  readonly type = RedDatasActionTypes.REDDATAS_EDITED;

  constructor(public payload: { reddata: RedData }) {}
}

export class RedDatasSaved implements Action {
  readonly type = RedDatasActionTypes.REDDATAS_SAVED;

  constructor(public payload: {reddata: RedData}) {}
}

export class RedDatasDeleted implements Action {
  readonly type = RedDatasActionTypes.REDDATAS_DELETED;

  constructor(public payload: { reddata: RedData }) {}
}

export class RedDatasDeletedAll implements Action { 
  readonly type = RedDatasActionTypes.REDDATAS_DELETEDALL;

  constructor(public payload: { reddata: RedData }) {}
}



export class RedDatasError implements Action {
  readonly type = RedDatasActionTypes.REDDATAS_ERROR;

  constructor(public payload: { error: any }) {}
}

export type RedDatasActions =
  | RedDatasQuery
  | RedDatasLoaded
  | RedDatasAdded
  | RedDatasEdited
  | RedDatasSaved
  | RedDatasDeleted
  | RedDatasDeletedAll
  | RedDatasError;
